import { authorityConfig } from '@/config'
import protectedAuthRoute from '@/middlewares/auth'

import Login from '@/views/Login'
import UserRegister from '@/views/user/Register/Register'
import UserRegisterSuccess from '@/views/user/Register/Success'
import UserProfile from '@/views/user/Profile'
import MailVerify from '@/views/user/MailVerify'
import PasswordResetMail from '@/views/user/PasswordResetMail/PasswordResetMail'
import PasswordResetMailSuccess from '@/views/user/PasswordResetMail/Success'
import ResetPassword from '@/views/user/PasswordResetMail/ResetPassword'
import ResetPasswordSuccess from '@/views/user/PasswordResetMail/ResetPasswordSuccess'

import NextengineCooperate from '@/views/nextengine/NextengineCooperate'

import Dashboard from '@/views/dashboard/Dashboard'
import ContactForm from '@/views/contact/ContactForm'
import ContactSuccess from '@/views/contact/ContactSuccess'

import SalesRegister from '@/views/sales/Register/Register'
import SalesEdit from '@/views/sales/Edit/Edit'
import SalesHistory from '@/views/sales/History/History'
import SalesShip from '@/views/sales/Ship/Ship'
import SalesRefundRegister from '@/views/sales/RefundRegister/Register'
import SalesRefundHistory from '@/views/sales/RefundHistory/History'

import OrderRegister from '@/views/order/Register/Register'
import OrderEdit from '@/views/order/Edit/Edit'
import OrderHistory from '@/views/order/History/History'
import OrderLoading from '@/views/order/Loading/Loading'

import MasterProduct from '@/views/master/Product/Product'

import StorageRegister from '@/views/storage/Register/Register'
import StorageEdit from '@/views/storage/Edit/Edit'
import StorageHistory from '@/views/storage/History/History'
import StorageAdjust from '@/views/storage/Adjust/Adjust'
import StorageAdjustHistory from '@/views/storage/AdjustHistory/History'
import StorageProductStocks from '@/views/storage/ProductStocks/ProductStocks'

import MasterSupplier from '@/views/master/Supplier/Supplier'
import MasterCustomer from '@/views/master/Customer/Customer'
import MasterNotePhrase from '@/views/master/NotePhrase/NotePhrase'
import MasterCustomerCategory from '@/views/master/CustomerCategory/CustomerCategory'
import MasterStockMoveReason from '@/views/master/StockMoveReason/StockMoveReason'
import MasterPaymentMethod from '@/views/master/PaymentMethod/PaymentMethod'
import MasterSuggestedReceivingLocation from '@/views/master/SuggestedReceivingLocation/SuggestedReceivingLocation'
import MasterStorage from '@/views/master/Storage/Storage'
import MasterTransferAccount from '@/views/master/TransferAccount/TransferAccount'

import CsvUpload from '@/views/csv/CsvUpload/CsvUpload'
import CsvHistory from '@/views/csv/CsvHistory/CsvHistory'
import Shop from '@/views/csv/Shop/Shop'
import CsvJdProduct from '@/views/csv/JdProduct/JdProduct'

import NeEcGoods from '@/views/nextengine/EcGoods/EcGoods'
import NeEcReceiveorder from '@/views/nextengine/EcReceiveorder/EcReceiveorderHistory'
import NeConfigEdit from '@/views/nextengine/NeConfigEdit'

import LedgerSheet from '@/views/ledgerSheet/LedgerSheet'

import ClosingMonth from '@/views/closingMonth/ClosingMonth'

import Maintenance from '@/views/maintenance/Maintenance'

import Tutorial from '@/views/Tutorial'

import NotFound from '@/views/NotFound'
import Kpi from '../views/kpi/kpi.vue'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Dashboard
  },
  // 認証
  {
    path: '/login',
    name: 'Login',
    component: Login
  },
  // ユーザ
  {
    path: '/user/register/:token',
    name: 'user.register.token',
    component: UserRegister
  },
  {
    path: '/user/register',
    name: 'user.register',
    component: UserRegister
  },
  {
    path: '/user/register/success',
    name: 'user.register.success',
    component: UserRegisterSuccess
  },
  {
    path: '/mail-verify',
    name: 'mail-verify',
    component: MailVerify
  },
  {
    path: '/user/profile',
    name: 'user.profile',
    component: UserProfile
  },
  {
    path: '/user/password-reset-mail',
    name: 'user.password-reset-mail',
    component: PasswordResetMail
  },
  {
    path: '/user/password-reset-mail/success',
    name: 'user.password-reset-mail.success',
    component: PasswordResetMailSuccess
  },
  // お問い合わせ
  {
    path: '/contact',
    name: 'contact',
    component: ContactForm
  },
  {
    path: '/contact/success',
    name: 'contact.success',
    component: ContactSuccess
  },
  // パスワードリセット
  {
    path: '/reset-password',
    name: 'reset-password',
    component: ResetPassword
  },
  {
    path: '/reset-password/success',
    name: 'reset-password.success',
    component: ResetPasswordSuccess
  },
  // ネクストエンジン初回連携
  {
    path: '/nextengine-cooperate',
    name: 'nextengine-cooperate',
    component: NextengineCooperate
  },
  // ダッシュボード
  {
    path: '/dashboard',
    name: 'dashboard',
    component: Dashboard
  },
  // 商品毎の統計データ
  {
    path: '/kpi',
    name: 'kpi',
    component: Kpi,
    beforeEnter: protectedAuthRoute,
    meta: {
      permissions: [
        authorityConfig.AUTHORITY_TYPE_ID.ADMIN,
        authorityConfig.AUTHORITY_TYPE_ID.USER
      ]
    }
  },
  // 販売
  {
    path: '/sales/register',
    name: 'sales.register',
    component: SalesRegister,
    beforeEnter: protectedAuthRoute,
    meta: {
      permissions: [
        authorityConfig.AUTHORITY_TYPE_ID.ADMIN,
        authorityConfig.AUTHORITY_TYPE_ID.USER,
        authorityConfig.AUTHORITY_TYPE_ID.PART_TIME
      ]
    }
  },
  {
    path: '/sales/edit',
    name: 'sales.edit',
    component: SalesEdit
  },
  {
    path: '/sales/history',
    name: 'sales.history',
    component: SalesHistory
  },
  // 出庫
  {
    path: '/sales/ship',
    name: 'sales.ship',
    component: SalesShip
  },
  // 返金
  {
    path: '/sales/refund/register',
    name: 'sales.refund.register',
    component: SalesRefundRegister,
    beforeEnter: protectedAuthRoute,
    meta: {
      permissions: [
        authorityConfig.AUTHORITY_TYPE_ID.ADMIN,
        authorityConfig.AUTHORITY_TYPE_ID.USER,
        authorityConfig.AUTHORITY_TYPE_ID.PART_TIME
      ]
    }
  },
  {
    path: '/sales/refund/history',
    name: 'sales.refund.history',
    component: SalesRefundHistory,
    beforeEnter: protectedAuthRoute,
    meta: {
      permissions: [
        authorityConfig.AUTHORITY_TYPE_ID.ADMIN,
        authorityConfig.AUTHORITY_TYPE_ID.USER,
        authorityConfig.AUTHORITY_TYPE_ID.PART_TIME
      ]
    }
  },
  // 発注
  {
    path: '/order/register',
    name: 'order.register',
    component: OrderRegister,
    beforeEnter: protectedAuthRoute,
    meta: {
      permissions: [
        authorityConfig.AUTHORITY_TYPE_ID.ADMIN,
        authorityConfig.AUTHORITY_TYPE_ID.USER
      ]
    }
  },
  {
    path: '/order/edit',
    name: 'order.edit',
    component: OrderEdit
  },
  {
    path: '/order/history',
    name: 'order.history',
    component: OrderHistory
  },
  // 入庫
  {
    path: '/order/loading',
    name: 'order.loading',
    component: OrderLoading
  },
  // 在庫管理
  {
    path: '/storage/register',
    name: 'storage.register',
    component: StorageRegister
  },
  {
    path: '/storage/edit',
    name: 'storage.edit',
    component: StorageEdit
  },
  {
    path: '/storage/history',
    name: 'storage.history',
    component: StorageHistory
  },
  {
    path: '/storage/adjust/register',
    name: 'storage.adjust.register',
    component: StorageAdjust
  },
  {
    path: '/storage/adjust/history',
    name: 'storage.adjust.history',
    component: StorageAdjustHistory
  },
  {
    path: '/storage/product-stocks',
    name: 'storage.productStocks',
    component: StorageProductStocks
  },

  // マスタ関連
  // 商品
  {
    path: '/master/product',
    name: 'master.product',
    component: MasterProduct,
    beforeEnter: protectedAuthRoute,
    meta: {
      permissions: [
        authorityConfig.AUTHORITY_TYPE_ID.ADMIN,
        authorityConfig.AUTHORITY_TYPE_ID.USER
      ]
    }
  },
  // 仕入先
  {
    path: '/master/supplier',
    name: 'master.supplier',
    component: MasterSupplier,
    beforeEnter: protectedAuthRoute,
    meta: {
      permissions: [
        authorityConfig.AUTHORITY_TYPE_ID.ADMIN,
        authorityConfig.AUTHORITY_TYPE_ID.USER
      ]
    }
  },
  // 顧客
  {
    path: '/master/customer',
    name: 'master.customer',
    component: MasterCustomer,
    beforeEnter: protectedAuthRoute,
    meta: {
      permissions: [
        authorityConfig.AUTHORITY_TYPE_ID.ADMIN,
        authorityConfig.AUTHORITY_TYPE_ID.USER
      ]
    }
  },
  // 備考定型文
  {
    path: '/master/note-phrase',
    name: 'master.notePhrase',
    component: MasterNotePhrase,
    beforeEnter: protectedAuthRoute,
    meta: {
      permissions: [
        authorityConfig.AUTHORITY_TYPE_ID.ADMIN,
        authorityConfig.AUTHORITY_TYPE_ID.USER
      ]
    }
  },
  // 顧客分類
  {
    path: '/master/customer-category',
    name: 'master.customerCategory',
    component: MasterCustomerCategory,
    beforeEnter: protectedAuthRoute,
    meta: {
      permissions: [
        authorityConfig.AUTHORITY_TYPE_ID.ADMIN,
        authorityConfig.AUTHORITY_TYPE_ID.USER
      ]
    }
  },
  // 入出金手段
  {
    path: '/master/payment-method',
    name: 'master.PaymentMethod',
    component: MasterPaymentMethod,
    beforeEnter: protectedAuthRoute,
    meta: {
      permissions: [
        authorityConfig.AUTHORITY_TYPE_ID.ADMIN,
        authorityConfig.AUTHORITY_TYPE_ID.USER
      ]
    }
  },
  // 希望入庫場所
  {
    path: '/master/suggested-receiving-location',
    name: 'master.suggestedReceivingLocation',
    component: MasterSuggestedReceivingLocation,
    beforeEnter: protectedAuthRoute,
    meta: {
      permissions: [
        authorityConfig.AUTHORITY_TYPE_ID.ADMIN,
        authorityConfig.AUTHORITY_TYPE_ID.USER
      ]
    }
  },
  // 在庫移動理由
  {
    path: '/master/storage-move-reason',
    name: 'master.stockMoveReason',
    component: MasterStockMoveReason,
    beforeEnter: protectedAuthRoute,
    meta: {
      permissions: [
        authorityConfig.AUTHORITY_TYPE_ID.ADMIN,
        authorityConfig.AUTHORITY_TYPE_ID.USER
      ]
    }
  },
  // 倉庫
  {
    path: '/master/storage',
    name: 'master.storage',
    component: MasterStorage,
    beforeEnter: protectedAuthRoute,
    meta: {
      permissions: [
        authorityConfig.AUTHORITY_TYPE_ID.ADMIN,
        authorityConfig.AUTHORITY_TYPE_ID.USER
      ]
    }
  },
  // 振込口座登録
  {
    path: '/master/transfer-account',
    name: 'master.transferAccount',
    component: MasterTransferAccount,
    beforeEnter: protectedAuthRoute,
    meta: {
      permissions: [
        authorityConfig.AUTHORITY_TYPE_ID.ADMIN,
        authorityConfig.AUTHORITY_TYPE_ID.USER
      ]
    }
  },

  // CSV
  {
    path: '/csv/csv-upload',
    name: 'csv.csvUpload',
    component: CsvUpload,
    beforeEnter: protectedAuthRoute,
    meta: {
      permissions: [
        authorityConfig.AUTHORITY_TYPE_ID.ADMIN,
        authorityConfig.AUTHORITY_TYPE_ID.USER,
        authorityConfig.AUTHORITY_TYPE_ID.PART_TIME
      ]
    }
  },
  {
    path: '/csv/csv-history',
    name: 'csv.csvHistory',
    component: CsvHistory,
    beforeEnter: protectedAuthRoute,
    meta: {
      permissions: [
        authorityConfig.AUTHORITY_TYPE_ID.ADMIN,
        authorityConfig.AUTHORITY_TYPE_ID.USER,
        authorityConfig.AUTHORITY_TYPE_ID.PART_TIME
      ]
    }
  },
  {
    path: '/csv/shop',
    name: 'csv.shop',
    component: Shop,
    beforeEnter: protectedAuthRoute,
    meta: {
      permissions: [
        authorityConfig.AUTHORITY_TYPE_ID.ADMIN,
        authorityConfig.AUTHORITY_TYPE_ID.USER
      ]
    }
  },

  // 締め処理
  {
    path: '/closing-month',
    name: 'closingMonth',
    component: ClosingMonth,
    beforeEnter: protectedAuthRoute,
    meta: {
      permissions: [
        authorityConfig.AUTHORITY_TYPE_ID.ADMIN,
        authorityConfig.AUTHORITY_TYPE_ID.USER
      ]
    }
  },
  {
    path: '/csv/jd-product',
    name: 'csv.jdProduct',
    component: CsvJdProduct,
    beforeEnter: protectedAuthRoute,
    meta: {
      permissions: [
        authorityConfig.AUTHORITY_TYPE_ID.ADMIN,
        authorityConfig.AUTHORITY_TYPE_ID.USER
      ]
    }
  },

  // ネクストエンジンEC販売商品一覧
  {
    path: '/nextengine/ec-goods-list',
    name: 'nextengine.ecGoodsList',
    component: NeEcGoods,
    beforeEnter: protectedAuthRoute,
    meta: {
      permissions: [
        authorityConfig.AUTHORITY_TYPE_ID.ADMIN,
        authorityConfig.AUTHORITY_TYPE_ID.USER
      ],
      isNextengine: true
    }
  },
  // ネクストエンジンEC販売履歴取込履歴
  {
    path: '/nextengine/ec-receiveorder-list',
    name: 'nextengine.ecReceiveorderList',
    component: NeEcReceiveorder,
    beforeEnter: protectedAuthRoute,
    meta: {
      permissions: [
        authorityConfig.AUTHORITY_TYPE_ID.ADMIN,
        authorityConfig.AUTHORITY_TYPE_ID.USER
      ],
      isNextengine: true
    }
  },
  // ネクストエンジン連携設定更新画面
  {
    path: '/nextengine/config-edit',
    name: 'nextengine.configEdit',
    component: NeConfigEdit,
    beforeEnter: protectedAuthRoute,
    meta: {
      permissions: [
        authorityConfig.AUTHORITY_TYPE_ID.ADMIN,
        authorityConfig.AUTHORITY_TYPE_ID.USER
      ],
      isNextengine: true
    }
  },

  // 帳票
  {
    path: '/ledger-sheet',
    name: 'ledgerSheet',
    component: LedgerSheet,
    beforeEnter: protectedAuthRoute,
    meta: {
      permissions: [
        authorityConfig.AUTHORITY_TYPE_ID.ADMIN,
        authorityConfig.AUTHORITY_TYPE_ID.USER
      ]
    }
  },

  // チュートリアル
  {
    path: '/tutorial',
    name: 'tutorial',
    component: Tutorial
  },

  {
    path: '/not-found',
    name: 'closeService',
    component: NotFound
  },
  // メンテナンス
  {
    path: '/maintenance',
    name: 'maintenance',
    component: Maintenance
  },
  {
    path: '/*',
    name: 'notFound',
    component: NotFound
  }
]

export default routes
